<template>
  <div>
    <v-card v-if="!lite">
      <WBDVacancyRatePageListFilter :vacancy-rate-list-filter-set="vacancyRateListFilterSet" />
      <v-card-actions>
        <v-spacer />
        <v-btn
          v-if="getActiveFilterNumber > 0"
          class="mr-1"
          text
          color="warning"
          @click="resetFilterSet"
        >
          {{ `Очистить` }}
        </v-btn>
        <v-btn
          color="success"
          dark
          class="mb-2"
          @click="loadVacancyRateList(1, options.itemsPerPage)"
        >
          Применить
        </v-btn>
      </v-card-actions>
    </v-card>

    <v-card-actions v-if="!loading">
      <v-spacer />
      <v-btn
        text
        color="warning"
      >
        <span> {{ searchResultLabel }} </span>
      </v-btn>
    </v-card-actions>
    <v-data-table
      fixed-header
      :height="tableHeight"
      :headers="headers"
      :items="vacancyRateList"
      :options.sync="options"
      :loading="loading"
      :server-items-length="getPaginator.total"
      :footer-props="footerProps"
      class="elevation-1"
    >
      <template v-slot:item.vacancy="{ item }">
        <ItemLinkView
          :label="undefined"
          :value="getVacancyViewHref({
            ...item.vacancy,
            organization: item.organization
          })"
          :link-text="`${item.vacancy.title || ' '}`"
        />
      </template>
      <template v-slot:item.organization="{ item }">
        <ItemLinkView
          :label="undefined"
          :value="getOrganizationViewHref(item.organization)"
          :link-text="`${item.organization.title || ' '}`"
        />
      </template>
      <template v-slot:item.options="{ item }">
        <v-btn
          v-if="editable"
          text
          x-small
          color="info"
          @click="onOpenEditModalShowMode(item)"
        >
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
      </template>
    </v-data-table>
    <CityFormModal
      v-if="selectedCity"
      :model.sync="selectedCity"
      :show-mode="editModalShowMode"
      @onCloseEditModalShowMode="onCloseEditModalShowMode"
    />
  </div>
</template>

<script>
import ListMixin from '@/mixins/list-mixin.vue'
import ApiMixin from '@/mixins/api-mixin'
import CityFormModal from '@/views/city/city-form-modal'
import WBDVacancyRatePageListFilter from '@/components/common/filter/vacancy-rate-list-filter'
import { pluriaizeRows } from '@/utils/plural-util'
import { offerDate } from '@/utils/dateUtl'

export default {
  name: 'WBDBVacancyRateList',
  components: { CityFormModal, WBDVacancyRatePageListFilter },
  mixins: [ListMixin, ApiMixin],
  props: {
    office: {
      type: Object
    },
    lite: {
      type: Boolean
    }
  },
  data: () => ({
    vacancyRateList: [],
    editable: false,
    loading: true,
    pagination: 0,
    selectedCity: null,
    editModalShowMode: false,
    vacancyRateListFilterSet: {
      searchQuery: null,
      region: null,
      office: null,
      organization: null,
      profession: null,
      locality: null,
      vacancy: null,
    },
    options: {},
    headers: [
      {
        text: 'создан',
        align: 'left',
        sortable: false,
        value: 'dateString',
      },
      {
        text: 'Ставка физ',
        align: 'left',
        sortable: false,
        value: 'payPerHour',
      },
      {
        text: 'Ставка СМЗ',
        align: 'left',
        sortable: false,
        value: 'selfEmployerPayPerHour',
      },
      {
        text: 'Вакансия',
        align: 'left',
        sortable: false,
        value: 'vacancy',
      },
      {
        text: 'Организация',
        align: 'left',
        sortable: false,
        value: 'organization',
      },
      {
        text: 'Регион',
        align: 'left',
        sortable: false,
        value: 'region.title',
      },
      {
        text: 'Город',
        align: 'left',
        sortable: false,
        value: 'locality.title',
      },
      { text: '', value: 'options' },
    ],

  }),
  computed: {
    searchResultLabel () {
      return `Найдено: ${this.pagination} ${pluriaizeRows(this.pagination)}`
    },
    getActiveFilterNumber () {
      const params = {
        ...this.vacancyRateListFilterSet
      }
      for (const [key, value] of Object.entries(params)) {
        if (!(value || (!value && (value === '0' || value === 0)))) {
          delete params[key]
        }
      }
      return Object.keys(params).length
    },
    getList () {
      return this.vacancyRateList
    },
    getPaginator () {
      // return this.$store.getters['profession/getPaginator']
      return { total: this.pagination }
    }
  },
  watch: {
    options: {
      handler () {
        this.loadVacancyRateList(this.options.page, this.options.itemsPerPage)
      },
      deep: true,
    },
  },
  async created () {
    if (this.office && this.office.id) {
      this.vacancyRateListFilterSet.office = this.office.id
    }
    this.options = {
      page: 1,
      itemsPerPage: this.footerProps.itemsPerPageOptions[1],
      sortBy: ['createdAt'],
      sortDesc: [true],
    }
    // await this.loadClientCityList()
  },
  methods: {
    displayExtra (item) {
      if (item && item.extra && item.extra.latitude && item.extra.longitude) {
        return `${item.extra.latitude}, ${item.extra.longitude}`
      }

      return ''
    },
    onOpenEditModalShowMode (city) {
      this.selectedCity = {
        ...city,
        latitude: null,
        longitude: null,
      }
      if (city.extra && city.extra.latitude && city.extra.longitude) {
        this.selectedCity.latitude = city.extra.latitude
        this.selectedCity.longitude = city.extra.longitude
      }
      this.editModalShowMode = true
    },
    onCloseEditModalShowMode () {
      this.save()
      this.editModalShowMode = false
    },
    async resetFilterSet () {
      const hasFilter = this.getActiveFilterNumber
      this.vacancyRateListFilterSet = {
        searchQuery: null,
        region: null,
        office: null,
        organization: null,
        profession: null,
        locality: null,
        vacancy: null,
      }

      this.eventsBus.$emit(this.eventNames.VACANCY_RATE_LISt_PAGE_FILTER_RESET)

      if (hasFilter > 0) {
        await this.loadVacancyRateList(1, this.options.itemsPerPage)
      }
    },
    async loadVacancyRateList (page, size) {
      this.vacancyRateList = []
      const params = { 'addRegion': '0', 'page[number]': page, 'page[size]': size }
      const { sortBy, sortDesc } = this.options

      if (sortBy && sortBy.length) {
        for (const [index, item] of sortBy.entries()) {
          params[`ordering[${item}]`] = sortDesc[index] ? 'DESC' : 'ASC'
        }
      }

      const { searchQuery, region, office, profession, locality, vacancy, organization } = this.vacancyRateListFilterSet

      if (searchQuery && searchQuery.trim().length > 0) {
        params.searchQuery = searchQuery
      }

      if (region) {
        params['region[id]'] = region
      }
      if (office) {
        params['office[id]'] = office
      }
      if (profession) {
        params['profession[id]'] = profession
      }
      if (locality) {
        params['locality[id]'] = locality
      }
      if (vacancy) {
        params['vacancy[id]'] = vacancy
      }
      if (organization) {
        params['organization[id]'] = organization
      }

      try {
        this.loading = true
        await this.getVacancyRateList(this.setModelRequestResult, params)
        this.loading = false
      } catch (error) {
        this.loading = false
      }
    },
    setModelRequestResult (requestResult) {
      if (requestResult && requestResult.error) {
        this.vacancyRateList = []
      } else {
        this.vacancyRateList = requestResult.modelList.map((item) => ({
          ...item,
          dateString: offerDate(item.createdAt, 'DD MMMM YYYY')
          // status: item.externalId ? 'Отправлен' : 'Создан',
        }))
        this.pagination = requestResult.total
      }
    },
  },
}
</script>
